import React from 'react';
import PropTypes from 'prop-types';

import { FormControlLabel, makeStyles, Switch, Text } from '@knockrentals/knock-shared-web';

import { SwitchKnobIcon } from '../../../../../../Components/Icons';
import { ACTIVE_LABEL, INACTIVE_LABEL } from '../constants';

const useStyles = makeStyles(() => ({
  formControl: {
    marginRight:'10px',
  },
  formControlInactive: {
    marginRight: '0px',
  },
  switch: {
    '&.Mui-checked': {
      '& .MuiIconButton-root': {
        padding: '6px',
      },
      '& .MuiTouchRipple-root': {
        width: '36px',
        height: '36px',
      },
    },
  },
  disabledSwitch: {
    opacity: 0.5,
    cursor: 'not-allowed',
    '& .MuiSwitch-switchBase': {
      cursor: 'not-allowed',
      '&.Mui-disabled': {
        '& .MuiSwitch-thumb': {
          backgroundColor: '#9e9e9e',
        },
      },
    },
    '& .MuiFormControlLabel-label': {
      cursor: 'not-allowed',
      color: '#9e9e9e',
    },
    '& svg circle': {
      fill: '#9e9e9e',
    },
  },
}));

export const ServiceStatusSwitch = ({ disabled, handleOnChange, isChecked, isInternalMode }) => {
  const classes = useStyles();
  const statusLabel = isChecked ? ACTIVE_LABEL : INACTIVE_LABEL;
  const switchClass = isChecked ? classes.formControl : classes.formControlInactive;
  const formControlClass = !isInternalMode ? classes.disabledSwitch : "";

  return (
    <FormControlLabel
      className={`${switchClass} ${formControlClass}`}
      control={
        <Switch
          checked={isChecked}
          checkedIcon={<SwitchKnobIcon />}
          className={classes.switch}
          color="primary"
          disabled={disabled}
          name="status"
          onChange={handleOnChange}
        />
      }
      disabled={disabled}
      label={<Text variant="body2">{statusLabel}</Text>}
    />
  );
};

ServiceStatusSwitch.propTypes = {
  disabled: PropTypes.bool,
  handleOnChange: PropTypes.func.isRequired,
  isChecked: PropTypes.bool.isRequired,
  isInternalMode: PropTypes.bool.isRequired,
};
